<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Личный кабинет</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="loginto">
                <v-text-field
                  v-model="logindata.Email"
                  label="Email"
                  name="Email"
                  prepend-icon="mdi-email"
                  type="text"
                />
                <v-text-field
                  v-model="logindata.password"
                  type="password"
                  label="Пароль"
                  prepend-icon="mdi-lock"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="info" align-center justify-center to="/register">Регистрация</v-btn>
              <v-spacer />
              <v-btn
                color="success"
                align-center
                justify-center
                type="submit"
                @click.prevent="loginto"
              >Вход</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
// @ is an alias to /src
import LoginService from '../api-services/login.services'
export default {
  name: "Home",
  components: {
    LoginService,
    profile:{}
  },
  mounted(){
    LoginService.getlk(this.$store.state.email)
  }
};
</script>
